import { useChannel } from "./ws/useChannel";
import useQuery, { useRevalidate } from "./useQuery";
import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";
import useDistinctShape from "@ui/lib/hooks/useDistinctShape";

const PATH = "/setting/translations" as const;

export const useTranslations = () => {
  const translations = useQuery(PATH).body;
  const revalidate = useRevalidate();
  const callback = useDebouncedCallback(
    () => {
      void revalidate(PATH);
    },
    [revalidate],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );

  useChannel({ key: "translations" }, callback, true);
  return useDistinctShape(translations);
};

export type Translation = ReturnType<typeof useTranslations>;
export type TranslationKeyEN = Translation["EN"];
export type TranslationKeyFR = Translation["FR"];
export type TranslationKey = keyof TranslationKeyEN;
